export function areValuesEqual(a: unknown, b: unknown): boolean {
    if (a === b) return true;
    if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object') {
        return false;
    }
    const keysA = Object.keys(a as object).sort();
    const keysB = Object.keys(b as object).sort();
    if (keysA.length !== keysB.length) return false;
    for (let i = 0; i < keysA.length; i++) {
        if (keysA[i] !== keysB[i]) return false;
    }
    const A = a as Record<string, unknown>;
    const B = b as Record<string, unknown>;
    for (const k of keysA) {
        if (A[k] !== B[k]) return false;
    }
    return true;
}

export const isNotNullish = (value: unknown): boolean => {
    return value !== undefined && value !== null;
};

export const isNotEmpty = (value: unknown): boolean => {
    if (!isNotNullish(value)) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    if (Array.isArray(value)) return value.some(isNotEmpty);
    if (typeof value === 'object') {
        return Object.values(value as Record<string, unknown>).some(isNotEmpty);
    }
    return true;
};
